import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class={{concat \"form-field__input \" this.inputClassNames}} placeholder={{this.placeholder}} disabled={{this.disabled}} />", {
  moduleName: "@dashboard/shared-ui/components/sq-field-input-percent.hbs"
});